export const RENEWAL_WRITE_OUT_MSG =
  "bees-360-inspection-renewal-write-out-benefit-rule";
export const ALL_WRITE_OUT_MSG = "inspection-renewal-write-out-benefit-rule";
export const NEW_BIZ_WRITE_OUT_MSG =
  "new-business-inspection-observation-write-out-benefit-rule";
